//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
// import Mapbox from 'mapbox-gl-vue'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      handoff: 'pickup',
      mounted: false
    }
  },
  props: {
    location: {
      type: Object,
      default: () => {},
    }
  },
  async mounted() {
    if (this.order && this.order.handoff) {
      this.handoff = this.order.handoff
    }
    const location = await this.$api.getLocation(this.location.id)
    this.location = location
    // mapboxgl.accessToken = process.env.MAPBOX_TOKEN
    // const map = new mapboxgl.Map({
    //   container: 'lmap',
    //   style: 'mapbox://styles/mapbox/outdoors-v11',
    //   center: [this.location.lng, this.location.lat],
    //   zoom: 7
    // })
    // Add zoom and rotation controls to the map.
    // map.addControl(new mapboxgl.NavigationControl())
    // for (const marker of this.geojson.features) {
    //   // Create a DOM element for each marker.
    //   const el = document.createElement('div')
    //   const width = 41.54
    //   const height = 50
    //   const button = document.createElement('button')
    //   button.innerHTML = 'Order Now'
    //   button.addEventListener('click', () => {
    //     this.startOrder(marker.properties.location)
    //   })
    //   el.className = 'marker'
    //   el.style.backgroundImage = 'url(https://a.storyblok.com/f/162041/x/1a832a0dc7/pin.svg)'
    //   el.style.width = `${width}px`
    //   el.style.height = `${height}px`
    //   el.style.backgroundSize = '100%'
    //   el.addEventListener('click', () => {
    //     const html = document.createElement('div')
    //     const distance = marker.properties.location.distance ? '<b>'+marker.properties.location.distance+' mi away</b>' : ''
    //     html.innerHTML = '<div><h4>'+marker.properties.location.city+','+marker.properties.location.state+'</h4>'+distance+'<p><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_501_38013)"><path d="M7.21281 6.73218L4.00196 12.5428L0.787158 6.73209C0.487611 6.17646 0.337274 5.55264 0.350844 4.92154C0.364426 4.28984 0.541754 3.67248 0.865483 3.12988C1.18921 2.58727 1.64826 2.138 2.1977 1.82601C2.74714 1.51402 3.36816 1.35 4 1.35C4.63184 1.35 5.25288 1.51402 5.80232 1.82601C6.35176 2.138 6.81078 2.58727 7.13451 3.12988C7.45824 3.67249 7.63559 4.28985 7.64917 4.92154C7.66274 5.55268 7.51239 6.17653 7.21281 6.73218ZM3.65859 6.51626L3.72688 6.17299L3.6586 6.51626C3.99806 6.58378 4.34993 6.54914 4.6697 6.41668C4.98948 6.28422 5.26278 6.05992 5.45507 5.77214C5.64737 5.48435 5.75 5.146 5.75 4.79989C5.75 4.33577 5.56565 3.89065 5.23745 3.56245C4.90926 3.23426 4.46412 3.04989 4 3.04989C3.65388 3.04989 3.31555 3.15252 3.02776 3.34481C2.73998 3.5371 2.51566 3.81042 2.38321 4.1302C2.25075 4.44997 2.2161 4.80184 2.28363 5.1413C2.35115 5.48077 2.51783 5.79259 2.76257 6.03733C3.00731 6.28208 3.31913 6.44874 3.65859 6.51626Z" stroke="#3D3D3D" stroke-width="0.7"></path></g> <defs><clipPath id="clip0_501_38013"><rect width="8" height="12" fill="white" transform="translate(0 1)"></rect></clipPath></defs></svg>'+marker.properties.location.address + '<br> ' + marker.properties.location.city + ', ' + marker.properties.location.state + ' ' + marker.properties.location.zip+'</p> <p><svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 7.5H5.15C5.15 7.59283 5.18687 7.68185 5.25251 7.74749L5.5 7.5ZM5.5 11.65C3.20802 11.65 1.35 9.79198 1.35 7.5H0.65C0.65 10.1786 2.82142 12.35 5.5 12.35V11.65ZM9.65 7.5C9.65 9.79198 7.79198 11.65 5.5 11.65V12.35C8.17858 12.35 10.35 10.1786 10.35 7.5H9.65ZM5.5 3.35C7.79198 3.35 9.65 5.20802 9.65 7.5H10.35C10.35 4.82142 8.17858 2.65 5.5 2.65V3.35ZM5.5 2.65C2.82142 2.65 0.65 4.82142 0.65 7.5H1.35C1.35 5.20802 3.20802 3.35 5.5 3.35V2.65ZM5.15 4.60714V7.5H5.85V4.60714H5.15ZM5.25251 7.74749L7.18108 9.67606L7.67606 9.18108L5.74749 7.25251L5.25251 7.74749Z" fill="black"></path></svg>'+this.openStatus(marker.properties.location)+'</p> <p><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.71236 1H2.28571C1.57563 1 1 1.57563 1 2.28571V3.57143C1 7.12183 3.87817 10 7.42857 10H8.71429C9.42437 10 10 9.42437 10 8.71429V7.82588C10 7.58238 9.86243 7.35978 9.64464 7.25089L8.09154 6.47434C7.74163 6.29939 7.31789 6.47491 7.19418 6.84604L7.00276 7.4203C6.87876 7.79228 6.49718 8.01372 6.1127 7.93683C4.57383 7.62905 3.37095 6.42617 3.06317 4.8873C2.98628 4.50282 3.20772 4.12124 3.57969 3.99724L4.29239 3.75968C4.61106 3.65345 4.79423 3.31978 4.71276 2.9939L4.33602 1.48694C4.26448 1.20076 4.00734 1 3.71236 1Z" stroke="#3D3D3D" stroke-width="0.7"></path></svg>(256) 891-1424</p></div>'
    //     html.appendChild(button)
    //     // create the popup
    //     const popup = new mapboxgl.Popup({ offset: 28 }).setDOMContent(html)
    //     // create the marker
    //     new mapboxgl.Marker(el)
    //     .setLngLat({ lng: marker.geometry.coordinates[0], lat: marker.geometry.coordinates[1] })
    //     .setPopup(popup) // sets a popup on this marker
    //     .addTo(map)
    //     map.flyTo({
    //       center: [marker.geometry.coordinates[0],marker.geometry.coordinates[1]],
    //       essential: true // this animation is considered essential with respect to prefers-reduced-motion
    //     , zoom: 14})
    //   })
    //   // Add markers to the map.
    //   new mapboxgl.Marker(el)
    //   .setLngLat(marker.geometry.coordinates)
    //   .addTo(map)
    // }
    setTimeout(() => {
      this.mounted = true
    },250)
  },
  computed: {
    ...mapState([ 'order' ]),
    isNotAvailable() {
      return !this.location.available
    }
    // geojson() {
    //   let geojson = {
    //     'type': 'FeatureCollection',
    //     'features': []
    //   }
    //   let feature = {
    //     'type': 'Feature',
    //     'properties': {
    //       'location': this.location
    //     },
    //     'geometry': {
    //       'type': 'Point',
    //       'coordinates': [this.location.lng, this.location.lat]
    //     }
    //   }
    //   geojson.features.push(feature)
    //   return geojson
    // },
  },
  methods: {
    async setHandoff(mode) {
      this.handoff = mode
      const location = await this.$api.getLocation(this.location.id)
      this.$store.commit('setLocation', location)
      await this.$api.getMenu()
      let order = null
      if (this.order && this.order.menu_id != location.menu_id) {
        order = await this.$api.transferOrder()
      } else {
        order = await this.$api.createOrder()
      }
      if (order) {
        if (this.handoff !== 'dispatch') {
          await this.$api.setHandoff(mode)
          this.$router.push('/order/')
        } else {
          this.$router.push('/locations?delivery=true')
        }
      }

    },
    openStatus(location) {
      let today = moment().format('ddd').toLowerCase()
      let hours = location.hours.find(h => h.day.toLowerCase() == today)
      let tomorrow = moment().add(1,'d').format('ddd').toLowerCase()

      if (hours !== undefined) {
        let open = moment(hours.open,'HH:mm')
        let close = moment(hours.close,'HH:mm')
        let now = moment()
        let isOpen = now > open && now < close

        let tomorrowHours = location.hours.find(h => h.day.toLowerCase() == tomorrow)
        console.log('tomorrow hours: ', tomorrowHours.day)
        let tomorrowOpen = tomorrowHours.open
        let tomorrowClose = tomorrowHours.close
        let tomorrowString = moment(tomorrow,'e').format('ddd')
        
        if (moment(close).format('h:mm A') == '12:00 AM' && moment(open).format('h:mm A') == '12:00 AM' && hours.holiday == null) {
          return 'Open 24 hours'
        } else if (moment(close).format('h:mm A') == '12:00 AM' && hours.holiday == null) {
          return 'Open until midnight'
        } else if (isOpen & hours.holiday == null) {
          return 'Open until '+moment(close).format('h:mm A')
        } else if (moment(open).diff(moment(now)) > 0 && hours.holiday == null) { // not open yet today
          return 'Opens at '+moment(open).format('h:mm A')
        } else if (tomorrowHours.holiday == null) { // opens tomorrow and not holiday tomorrow
          return 'Opens tomorrow at '+moment(tomorrowOpen,'HH:mm').format('h:mm A')
        } else { // closed and holiday tomorrow
          return 'Closed for holiday'
        }
      } else {
        return 'Closed'
      }
    },
    phone(s) {
      let cleaned = ('' + s).replace(/\D/g, '')
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    },
    state(abbr) {
      let states = [
        ['Arizona', 'AZ'],
        ['Alabama', 'AL'],
        ['Alaska', 'AK'],
        ['Arkansas', 'AR'],
        ['California', 'CA'],
        ['Colorado', 'CO'],
        ['Connecticut', 'CT'],
        ['Delaware', 'DE'],
        ['Florida', 'FL'],
        ['Georgia', 'GA'],
        ['Hawaii', 'HI'],
        ['Idaho', 'ID'],
        ['Illinois', 'IL'],
        ['Indiana', 'IN'],
        ['Iowa', 'IA'],
        ['Kansas', 'KS'],
        ['Kentucky', 'KY'],
        ['Louisiana', 'LA'],
        ['Maine', 'ME'],
        ['Maryland', 'MD'],
        ['Massachusetts', 'MA'],
        ['Michigan', 'MI'],
        ['Minnesota', 'MN'],
        ['Mississippi', 'MS'],
        ['Missouri', 'MO'],
        ['Montana', 'MT'],
        ['Nebraska', 'NE'],
        ['Nevada', 'NV'],
        ['New Hampshire', 'NH'],
        ['New Jersey', 'NJ'],
        ['New Mexico', 'NM'],
        ['New York', 'NY'],
        ['North Carolina', 'NC'],
        ['North Dakota', 'ND'],
        ['Ohio', 'OH'],
        ['Oklahoma', 'OK'],
        ['Oregon', 'OR'],
        ['Pennsylvania', 'PA'],
        ['Rhode Island', 'RI'],
        ['South Carolina', 'SC'],
        ['South Dakota', 'SD'],
        ['Tennessee', 'TN'],
        ['Texas', 'TX'],
        ['Utah', 'UT'],
        ['Vermont', 'VT'],
        ['Virginia', 'VA'],
        ['Washington', 'WA'],
        ['West Virginia', 'WV'],
        ['Wisconsin', 'WI'],
        ['Wyoming', 'WY'],
      ]
      for (var i = 0; i < states.length; i++) {
        if (states[i][1] == abbr) {
          return states[i][0]
        }
      }
    }
  }
}
